import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "list"]

  connect() {
    this.files = []
    this.updateList()
  }

  // Called when files are selected
  filesSelected(event) {
    // Add newly selected files to our array
    for (const file of event.target.files) {
      this.files.push(file)
    }
    this.syncInput()
    this.updateList()
  }

  // Remove a file by index
  removeFile(event) {
    event.preventDefault()
    const index = parseInt(event.params.index)
    this.files.splice(index, 1)
    this.syncInput()
    this.updateList()
  }

  // Sync our file array back to the input element
  syncInput() {
    const dt = new DataTransfer()
    for (const file of this.files) {
      dt.items.add(file)
    }
    this.inputTarget.files = dt.files
  }

  updateList() {
    if (this.files.length === 0) {
      this.listTarget.innerHTML = ''
      return
    }

    const items = this.files.map((file, i) => `
      <div class="mb-1">
        <i class="fa-solid fa-file me-1"></i>
        ${this.escapeHtml(file.name)}
        <a href="#" class="ms-2" data-action="click->file-list#removeFile" data-file-list-index-param="${i}">
          <i class="fa-regular fa-trash-can"></i>
        </a>
      </div>
    `).join('')

    this.listTarget.innerHTML = `<div class="mt-2">${items}</div>`
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
